module.exports = __webpack_public_path__ + "static/media/privacypolicy.89094e89.htm";